export default function BannerFinal() {
  return (
    <section style={{ 
      textAlign: 'center', 
      padding: '5rem 2rem', 
      background: 'linear-gradient(to top, var(--black), var(--dark-gray))',
      borderTop: '1px solid var(--accent)'
    }}>
      <h2 style={{
        fontSize: '2.5rem',
        marginBottom: '2rem',
      }}>
        Conte com uma <span className="gray-text">advocacia moderna</span> e eficiente
      </h2>
      <p style={{
        fontSize: '1.2rem',
        maxWidth: '700px',
        margin: '0 auto 2rem',
      }}>
        Somos um escritório de advocacia especializado em direito do trabalho e direito previdenciário. Nosso público-alvo são trabalhadores em geral e segurados do INSS.
      </p>
      <a
        href="https://tintim.link/whatsapp/f29b407c-6594-4bba-b0aa-f5442f711a68/e7405481-419a-4fdb-8030-9aee45f67a3a"
        target="_blank"
        rel="noreferrer"
        style={{
          padding: '0.75rem 2.5rem',
          fontSize: '1.1rem',
          fontWeight: '600',
          background: '#25D366',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '10px',
          textDecoration: 'none'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'translateY(-3px)';
          e.currentTarget.style.boxShadow = '0 8px 20px rgba(37, 211, 102, 0.4)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
        }}>
        <i className="fab fa-whatsapp" style={{ fontSize: '1.2em' }}></i>
        Agendar Agora
      </a>
    </section>
  )
}